import React from 'react'
import Navbar from '../inc/Navbar'
import  aboutus from "../images/project_aerocity about.jpg";

function Aboutus() {
  return (
    <div>
          <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
              <div className="album py-1">
        <div className="container">
          <div className="row ">
            <div className="col-md-6 mt-0">
<h2>Unicorn Aerocity –<b> About Us</b></h2>
<h5>✈️ About Unicorn Aerocity</h5>
<h6 className='nearairpotkolkata mb-2'>Unicorn Aerocity is a premium residential plotted development by Novesta Group, strategically located near Netaji Subhas Chandra Bose International Airport, Kolkata. Designed to offer a perfect blend of modern lifestyle and high-return investment opportunities, Unicorn Aerocity is one of the most promising land projects in the airport corridor of Kolkata.
We don’t just sell plots — we deliver future-ready investment opportunities and dream bungalow living spaces.</h6>
<h6 className='nearairpotkolkata mb-2'>📍 Prime Location Advantage</h6>
<h6>Unicorn Aerocity is located near NH-12 in Madhyamgram, offering excellent connectivity to major hubs like New Town Kolkata and Rajarhat.</h6>

<p className='mb-1'> ✔ Just minutes from Kolkata Airpor</p>
<p className='mb-1'> ✔ Easy access to schools, hospitals, malls & railway station
</p>
<p className='mb-3'> ✔ Rapidly developing high-growth zone</p>
<h6>This strategic location ensures strong appreciation potential in the next 3–5 years. </h6>
<h6 className='nearairpotkolkata mb-2'><b>🏡 Our Vision</b> <br/>
At Unicorn Aerocity, our vision is to create a secure, eco-friendly, and premium gated community where families can build their dream homes and investors can enjoy long-term value growth.
We aim to redefine plotted development in Kolkata by combining:
Modern infrastructure
Sustainable living
Smart investment planning</h6>
<h5>🌟 Why Choose Unicorn Aerocity?</h5>
<p className='mb-1'>✔ 100% Legal & Transparent Documentation</p>
<p className='mb-1'>✔ Ready for Registry & Mutation</p>
<p className='mb-1'>✔ Gated Community with 24/7 Security</p>
<p className='mb-1'>✔ Plot Sizes: 1000 – 4000 sq.ft</p>
<p className='mb-1'>✔ G+1 Construction Approved</p>
<p className='mb-1'>✔ Flexible Payment Options</p>
<p className='mb-3'>✔ Ideal for End-Users & Investors</p>
<h6>The project offers residential plots starting from approx. ₹40 Lakhs onwards, making it accessible for both first-time buyers and seasoned investors. �
Housing +1
🏗️ Modern Amenities
Unicorn Aerocity provides a complete lifestyle experience with over 30+ amenities:
Club House & Community Hall
Swimming Pool & Gym
Children’s Park & Indoor Games
24×7 CCTV & Security
Underground Electricity & Water Supply
Wi-Fi Enabled Campus
Landscaped Green Spaces
These features create a modern township environment with comfort and convenience. �
Novesta Group
📈 Investment Potential
Located in a fast-growing airport zone, Unicorn Aerocity offers:
High appreciation value
Strong rental & resale demand
Proximity to IT hubs and business districts
Ideal for villa, bungalow, or farmhouse development
It is one of the most demanded land investment opportunities near Kolkata Airport.</h6>

                </div>
                 <div className="col-md-6 mt-0">
             <img src={aboutus} className="card-img-top" alt="uniocornaerocity"/>

                </div>
                </div>
                </div>
            </div>
            <br/>

    </div>
  )
}

export default Aboutus